import classNames from 'classnames'
import React from 'react'

import { IconComponent } from '../../types'

interface AuthMethodOptionProps {
  icon?: IconComponent
  label: string
  onClick?: () => void
  disabled?: boolean
  variant?: 'primary' | 'secondary'
  type?: 'button' | 'submit'
}

export const AuthMethodOption: React.FC<AuthMethodOptionProps> = ({
  icon: Icon,
  label,
  onClick,
  disabled,
  variant = 'secondary',
  type = 'button'
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        'w-full rounded-full min-h-[52px] px-6 cursor-pointer flex items-center gap-2.5 justify-center',
        'text-[14.5px] font-medium disabled:opacity-50 disabled:pointer-events-none transition-colors',
        {
          'bg-primary text-white hover:bg-black': variant === 'primary',
          'bg-white text-primary border border-neutralBlack-200 hover:bg-neutralBlack-50':
            variant === 'secondary'
        }
      )}
    >
      {Icon && <Icon className="size-4 align-middle" />}
      <span className="leading-none">{label}</span>
    </button>
  )
}
